/** Detail page top-bar and tab action buttons (Purchase Order reference design). */
export const detailActionButtonCss = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #d5deea !important;
  border-radius: 6px;
  background: #fff !important;
  color: #1249bf !important;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
  width: max-content;

  &:hover:not(:disabled) {
    background: #f4f7ff !important;
    border-color: #2060ea !important;
    color: #1249bf !important;
  }

  &:disabled {
    background: #f7f8f9 !important;
    border-color: #e5eaf0 !important;
    color: rgba(0, 0, 0, 0.25) !important;
    cursor: not-allowed;
  }
`;

export const tabActionButtonCss = detailActionButtonCss;
